import { blurRoutingNumberAction } from 'reg_redesign/actions';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import React from 'react';

const subHeadingStyle = {
  fontSize: '16px',
  fontStyle: 'italic'
};

const spanStyle = {
  fontWeight: 700
};
export default {
  defaultNextPage: 'page-12',
  content: [
    configureProgressBar(71),
    configureTitle('Where do you bank?', 'bankTitle', {
      props: {
        containerStyle: {
          marginBottom: '0'
        }
      }
    }),
    configureTitle(
      <p css={subHeadingStyle}>
        Please provide the account that receives the{' '}
        <span css={spanStyle}>majority</span> of your income.
      </p>,
      'subTitle',
      {
        props: {
          containerStyle: {
            marginTop: '0'
          }
        }
      }
    ),
    {
      component: BasicInput,
      name: 'routingNumber',
      props: {
        id: 'routingNumber',
        label: 'Routing Number',
        isNumeric: true,
        maxLength: 9,
        onBlur: blurRoutingNumberAction,
        onMount: blurRoutingNumberAction,
        formControlStyle: {
          marginBottom: '1.5rem'
        }
      }
    },
    {
      component: BasicInput,
      name: 'bankName',
      props: {
        id: 'bankName',
        label: 'Bank Name',
        isVisible: false,
        formControlStyle: {
          marginBottom: '1.5rem'
        }
      }
    },
    {
      component: BasicInput,
      name: 'accountNumber',
      props: {
        id: 'accountNumber',
        label: 'Account Number',
        isNumeric: true,
        maxLength: 17,
        formControlStyle: {
          marginBottom: '1.5rem'
        }
      }
    },
    {
      component: BasicInput,
      name: 'confirmAccountNumber',
      props: {
        id: 'confirmAccountNumber',
        label: 'Confirm Account Number',
        isNumeric: true,
        maxLength: 17
      }
    },
    nextButtonConfig('page-11')
  ]
};
